import { Icon } from "@legal-500/legal500-design-system";
import styles from "./DocumentParsing.module.css";

type BreadcrumbProps = {
  path: string;
  onNavigate: (path: string) => void;
  onGoUp: () => void;
  canGoUp: boolean;
};

export function Breadcrumb({ path, onNavigate, onGoUp, canGoUp }: BreadcrumbProps) {
  const segments = path.split("/");

  return (
    <nav className={styles.breadcrumb} aria-label="Folder navigation">
      {canGoUp && (
        <button
          type="button"
          className={styles.breadcrumbBack}
          onClick={onGoUp}
          aria-label="Go up one folder"
        >
          <Icon icon="chevron-left" size="small" />
        </button>
      )}
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1;
        const segmentPath = segments.slice(0, index + 1).join("/");
        return (
          <span key={segmentPath} className={styles.breadcrumbItem}>
            {index > 0 && (
              <span className={styles.breadcrumbSeparator} aria-hidden="true">
                /
              </span>
            )}
            {isLast ? (
              <span className={styles.breadcrumbCurrent} aria-current="location">
                {segment}
              </span>
            ) : (
              <button
                type="button"
                className={styles.breadcrumbLink}
                onClick={() => onNavigate(segmentPath)}
              >
                {segment}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
